import ApplyLeave from "components/modals/Timetracker/ApplyLeave";
import { useState } from "react";

const ApplyLeaveButton = ({ user }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <button className="apply-leave-btn" onClick={() => setShowModal(true)}>
        Apply Leave
      </button>
      {showModal ? (
        <ApplyLeave onClose={() => setShowModal(false)} user={user} />
      ) : null}
    </>
  );
};

export default ApplyLeaveButton;
